import React from 'react';
import '../styles/_step.scss';

export default function WaitingStep({ stepNumber }) {
  return <div className="step--waiting-step">{stepNumber.toString()}</div>;
}